<template>
  <div class="pa-2">
    <apexchart :height="chartHeight" :options="chartOptions" :series="series" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { toEur } from '@/mixins/filter';

export default {
  name: 'DashboardChart',
  props: {
    item: {}
  },
  data: function() {
    return {};
  },
  computed: {
    ...mapState('sshcp', ['dashboard']),
    chartOptions() {
      const labels = this.dashboard?.formRequestGroup?.map(item => item.name);
      return {
        chart: {
          type: 'line',
          toolbar: {
            tools: {
              download: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
              reset: false
            }
          }
        },
        legend: {
          show: false
        },
        stroke: {
          curve: 'smooth',
          width: [0, 4]
        },
        dataLabels: {
          enabled: false,
          enabledOnSeries: [0],
          offsetY: -15,
          background: {
            enabled: false
          }
        },
        labels,
        xaxis: {
          // type: 'datetime'
        },
        yaxis: [
          // Amount of Budget
          {
            title: {
              text: 'in MIDR'
            }
          },
          // Request
          {
            opposite: true,
            title: {
              // text: ''
            }
          }
        ],
        colors: ['#98ECFF', '#c854b0', '#F2994A'],
        plotOptions: {
          bar: {
            horizontal: false,
            borderRadius: 20,

            columnWidth: '30'
            // endingShape: 'rounded'
          }
        }
      };
    },
    series() {
      return [
        {
          name: 'Amount of Budget',
          type: 'column',
          data: this.dashboard?.formRequestGroup?.map(
            item => +toEur(item.amount_budget)
          )
        },
        {
          name: 'Request',
          type: 'line',
          data: this.dashboard?.formRequestGroup?.map(
            item => item.number_of_requests
          )
        }
        // {
        //   name: 'Average of Support',
        //   type: 'column',
        //   data: this.dashboard?.result?.map(item => item.average_support)
        // }
      ];
    },
    chartHeight() {
      return 250;
    }
  }
};
</script>
